export class AppConstants {
  public static ROLE_LEARNER = 'Learner';

  // Advance types of control the call
  public static ADVANCE_TYPE_MANUAL: string = 'MANUAL';
  public static ADVANCE_TYPE_AUTOMATIC: string = 'AUTOMATIC';

  // Call Types
  public static CALL_TYPE_GUIDED: string = 'GUIDED';
  public static CALL_TYPE_CONVERSATIONAL: string = 'CONVERSATIONAL';
  public static CALL_TYPE_FRAMING: string = 'FRAMING';

  // Practice Call Analysis Prompt Types
  public static SCORE_OVERALL_PROMPT_TYPE: string = 'SCORE_OVERALL';
  public static SCORE_CUSTOMIZED_PROMPT_TYPE: string = 'SCORE_CUSTOMIZED';
  public static SCORE_SKILLS_PROMPT_TYPE: string = 'SCORE_SKILLS';
  public static CLEAN_TRANSCRIPT_PROMPT_TYPE: string = 'CLEAN_TRANSCRIPT_V2';
  public static SCORE_MESSEGE_ADHERENCE_PROMPT_TYPE: string =
    'MESSAGE_ADHERENCE';
  public static SCORE_MESSAGE_ADHERENCE_V2_PROMPT_TYPE: string =
    'MESSAGE_ADHERENCE_V2';
  public static SCORE_COMPLIANCE: string = 'COMPLIANCE';
  public static COMPLIANCE_PROSECUTOR: string = 'COMPLIANCE_PROSECUTOR';
  public static ASSESSMENT_RESULTS_PROMPT_TYPE: string = 'ASSESSMENT_RESULTS';
  public static ACCURACY_CLAIM_VERIFICATION_PROMPT_TYPE: string =
    'ACCURACY_CLAIM_VERIFICATION';

  // Polling
  public static RESULTS_POLLING_DURATION_MS: number = 120_000;
  public static RESULTS_POLLING_INTERVAL_MS: number = 5_000;

  // Practice Types
  public static TYPE_CERTIFICATION: string = 'CERTIFICATION';
  public static TYPE_PRACTICE: string = 'PRACTICE';
  public static TYPE_PATHWAY: string = 'PATHWAY';

  // Feature Flags
  public static MY_TEAMS_UI: string = 'My_Teams';
  public static NEW_RESULT_UI: string = 'New_Results_UI';
  public static TRANSCRIPT_TAB: string = 'Transcript_Tab';
  public static PATHWAY_REVIEW_MATERIAL: string = 'Pathway_Review_Material';
  public static LEADERBOARD_SKILLS_FILTER_UI: string =
    'Leaderboard_Skills_Filter_UI';
  public static USER_TAB: string = 'User_Tab';
  public static INDIVIDUAL_ASSIGNMENT_VIEW: string =
    'Individual_Assignment_View';
  public static INDIVIDUAL_USER_VIEW: string = 'Individual_User_View';
  public static SIMULATION_REPORT_VIEW: string = 'Simulation_Report_View';
  public static KEY_WORDS: string = 'Key_Words';
  public static DEMO_MODE: string = 'Demo_Mode';
  public static ASSEMBLY_AWAIT_FINAL: string = 'Assembly_Await_Final';
  public static USER_HIGHLIGHTS: string = 'User_Highlights';
  public static CERTIFICATION_VIDEO_ACKNOWLEDGEMENT: string = 'Certification_Video_Acknowledgement';
  public static REPORTING_ASSIGNMENT_HIGHLIGHTS: string = 'Reporting_Assignment_Highlights';
  public static REPORTING_ASSIGNMENT_STATUS_FILTER: string = 'Reporting_Assignment_Status_Filter';
  public static SELF_SERVE_USER_MANAGEMENT: string = 'Self_Serve_User_Management';
  public static ADMIN_NAV: string = 'Admin_Nav';
  public static SELF_AUTHORING_ROLEPLAY: string = 'SELF_AUTHORING_ROLEPLAY';
  public static SELF_AUTHORING_KNOWLEDGE_CHECK: string = 'Self_Authoring_Knowledge_Check';
  public static ACCURACY_FEEDBACK: string = 'ACCURACY_FEEDBACK';
  public static COMPLIANCE_SCORE_IMPACT: string = 'COMPLIANCE_SCORE_IMPACT';
  public static COMPLIANCE_SAMPLE_QUOTE: string = 'COMPLIANCE_SAMPLE_QUOTE';
  public static SCREENSHARE: string = 'Screen_Share';

  // Account Features (Product Features tab, read via AccountFeatureService). Declared readonly,
  // not string, so they stay assignable to IAccountFeatureKey.
  public static readonly ACCOUNT_FEATURE_AI_INTERACTION_NOTIFICATION = 'AI_INTERACTION_NOTIFICATION';
  public static readonly ACCOUNT_FEATURE_CUSTOM_RESULT_MESSAGING = 'CUSTOM_RESULT_MESSAGING';
  public static readonly ACCOUNT_FEATURE_HIDE_INDIVIDUAL_USER_DATA = 'HIDE_INDIVIDUAL_USER_DATA';
  public static readonly ACCOUNT_FEATURE_HIDE_RESULTS = 'HIDE_RESULTS';
  public static readonly ACCOUNT_FEATURE_LEADERBOARD_TAB_VISIBILITY = 'LEADERBOARD_TAB_VISIBILITY';
  public static readonly ACCOUNT_FEATURE_VIDEO_CERT_KNOWLEDGE_CHECK_ACK = 'VIDEO_CERT_KNOWLEDGE_CHECK_ACK';

  // View types
  public static VIEW_DEVICE_SETTINGS: string = 'DEVICE-SETTINGS';
  public static VIEW_PRE_CALL: string = 'COACH';
  public static VIEW_PRACTICE: string = 'PRACTICE';
  public static NEW_REPORTING_UI: string = 'New_Reporting_UI';
  public static LEADERBOARD_UI: string = 'Leaderboard_UI';
  public static PATHWAY_QUIZ_RESULTS_LOADING_STATE: string = 'pathway-quiz-results-loading-state';
  public static KC_RESULTS_TOAST_NOTIFICATION: string = 'kc-results-toast-notification';
  public static CALL_RATIO_5PT_0MIN: string = 'RATIO_5PT_0MIN';
  public static PERSONALISED_PRACTICE_UI: string = 'Personalized_Practice_UI';

  public static COMPLETE_ASSIGNMENT_STATUS: string = 'complete';
  public static ACTIVE_ASSIGNMENT_STATUS: string = 'active';
  public static STAGED_ASSIGNMENT_STATUS: string = 'staged';
  public static CLOSED_ASSIGNMENT_STATUS: string = 'closed';

  public static UPCOMING_ASSIGNMENT_STATUS: string = 'UPCOMING';
  public static NOT_STARTED_ASSIGNMENT_STATUS: string = 'NOT_STARTED';
  public static IN_PROGRESS_ASSIGNMENT_STATUS: string = 'IN_PROGRESS';
  public static TEST_ASSIGNMENT_STATUS: string = 'TEST_ASSIGNMENT';
  public static COMPLETED_ASSIGNMENT_STATUS: string = 'COMPLETED';
  public static CERTIFIED_ASSIGNMENT_STATUS: string = 'CERTIFIED';
  public static NOT_CERTIFIED_ASSIGNMENT_STATUS: string = 'NOT_CERTIFIED';
  public static ENDED_ASSIGNMENT_STATUS: string = 'ENDED';
  public static CLOSED_ASSIGNMENT_STATUS_UPPER: string = 'CLOSED';
  public static COMPLETE_ASSIGNMENT_STATUS_UPPER: string = 'COMPLETE';
  public static STAGED_ASSIGNMENT_STATUS_UPPER: string = 'STAGED';
  public static ACTIVE_ASSIGNMENT_STATUS_UPPER: string = 'ACTIVE';
  public static AUTHOR_TESTING_ASSIGNMENT_STATUS_UPPER: string =
    'AUTHOR_TESTING';

  // Quiz result outcomes (pathway)
  public static QUIZ_PASSED_NEXT_STEP = 'QUIZ_PASSED_NEXT_STEP';
  public static QUIZ_PASSED_LAST_STEP = 'QUIZ_PASSED_LAST_STEP';
  public static QUIZ_FAILED_PREVIOUS_STEP = 'QUIZ_FAILED_PREVIOUS_STEP';
  public static QUIZ_FAILED_LAST_STEP = 'QUIZ_FAILED_LAST_STEP';
  public static QUIZ_FAILED_MAX_ATTEMPTS_REACHED =
    'QUIZ_FAILED_MAX_ATTEMPTS_REACHED';
}
